import { useTranslation } from 'react-i18next';


import styles from './CVPairList.module.css';
import CVPairBlock from '../CVPairBlock/CVPairBlock';
import { useState } from 'react';

function CVPairList({ children, isDark, cv_Pair, onRemove, formik, ...props }) {
    const [isSelected, setIsSelected] = useState('')
    const { t } = useTranslation();
    return (
        <div {...props} className={styles.list} >
            {cv_Pair && cv_Pair.map((single) => { 
                return (
                    <CVPairBlock
                        key={single.id}
                        setIsSelected={setIsSelected}
                        isSelected={isSelected}
                        id={single.id}
                        selectPrimaryPair={() => {
                            if (single.isPrimary !== true) {
                                let updatedCVPair = formik.values.cv_Pair.map((e) => {
                                    if (e.id === single.id) {
                                        e.isPrimary = true;
                                    } else {
                                        e.isPrimary = false;
                                    }
                                    return e;
                                });
                                formik.setFieldValue('cv_Pair', updatedCVPair);
                            }
                        }}
                        isDark={isDark}
                        isPrimary={single.isPrimary ? true : false}
                        cv={single.cv_file.name && single.cv_file.name}
                        coverletter={single.cv_ref_letter.name && single.cv_ref_letter.name}
                        video_cv={single.video_cv?.name && single.video_cv.name}
                        onRemove={onRemove}
                    />
                )
            })}
        </div>
    );
}

export default CVPairList;